import { withAnalyticOnEvent } from 'react-shisell';

export default <T extends { onClick: () => void }>(element: string, extra?: { [key: string]: any }) =>
  withAnalyticOnEvent<T>({
    eventName: 'onClick',
    analyticName: 'Click',
    extras: Object.assign({}, extra, {
      ActionId: element,
    }),
  });



// WEBPACK FOOTER //
// ./packages/platform-utils/analytics/hoc/withClickAnalytic.ts